module.exports = __webpack_public_path__ + "static/img/intro-cont04.7aa680a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_b2c/intro-cont04.png
// module id = fkyx
// module chunks = 0